import { Poppins, Quicksand } from 'next/font/google';
import Image from 'next/image';
import Link from 'next/link';
import React from 'react'
const popins = Poppins({weight:"500",subsets:['latin']})
const popinsfw = Poppins({weight:"400",subsets:['latin']})
const extrapopins = Poppins({weight:"600", subsets:['latin']});
const quickSand = Quicksand({weight:"400",subsets:['latin']})
export default function BlogCards({BlogCardsData,hideTitle}) {

  return (
    <>
    <section className='container'>
        <div className=''>
     {hideTitle && (   <><h1 className={`fs-33 mfs-19 cb tac ${extrapopins.className}`}>Latest News <span className='ylw-clr'> Blogs </span></h1>
     <p className={`fs-16 tac mt32 mmt20 ${popins.className}`}>Join our latest blogs at Learnsoft to explore the newest insights in IT training, career tips, and industry updates</p></>
             )}
         <div className={`df fjse fw gap5 mt10 mfjc mfac`}>
         {BlogCardsData.map((items,index)=>{
              return(
                <Link href={`${items.path}`} key={index}>
            <div className='blog-cards mt22 pd10' >
             
                <div className={`tac`}>
                <Image className='mdn' src={items.img} width={380} height={269} alt={`${items.blogHeading}-Imgs`} loading='lazy'/>
                <Image layout='responsive' className='dn mdb' src={items.img} width={380} height={269} alt={`${items.blogHeading}-Imgs`} loading='lazy'/>
                </div>
                <div className={``}>
                <h6 className={`fs-20 pdt10 tac ${popins.className}`}>{items.blogHeading}</h6>
                    <p className={`fs-16 pdt10 ${popins.className}`}>{items.cnt}</p>
                    <p className={`fs-14 pdt15 ${popinsfw}`}><span><Image src={"/new-blog-cards/date-icon.svg"} width={24} height={24} alt='Date-Icon' loading='lazy'/> </span>{items.publishDate}</p>
              </div>
            </div>
            </Link>
            )})}
         </div>
         
        </div>
    </section>
    <style jsx>
        {`
    .blog-cards{
      width: 380px;
      border: 1px solid #000;
      border-radius: 10px;
      box-shadow: 0px 4px 16px 2px #00000040;
      height: auto;
      
      }
      @media only screen and (max-width: 570px){
          .blog-cards{
      width: 280px;
      border: 1px solid #000;
      border-radius: 10px;
      box-shadow: 0px 4px 16px 2px #00000040;
      height: auto;
      
      }
      }
        `}
    </style>
    </>
  )
}
